const DEFAULT_CHAT_URL = "https://api.timeweb.ai/v1/chat/completions";
const DEFAULT_MODEL = "dashscope/qwen3.5-flash";

/**
 * Resolve OpenAI-compatible chat/completions URL from env.
 * Supports full URL (AI_CHAT_URL) or base (AI_BASE_URL → …/v1/chat/completions).
 */
export function resolveChatCompletionsUrl(env) {
  const full =
    env.AI_CHAT_URL ||
    env.VITE_AI_CHAT_URL ||
    env.OPENROUTER_CHAT_URL;
  if (full) return full.replace(/\/$/, "");

  const base =
    env.AI_BASE_URL ||
    env.VITE_AI_BASE_URL ||
    env.TIMEWEB_AI_BASE_URL ||
    env.OPENROUTER_BASE_URL;
  if (base) {
    const b = base.replace(/\/$/, "");
    if (b.endsWith("/chat/completions")) return b;
    return `${b}/chat/completions`;
  }

  return DEFAULT_CHAT_URL;
}

export function getAiChatConfig(env = process.env) {
  const apiKey =
    env.AI_API_KEY ||
    env.TIMEWEB_AI_API_KEY ||
    env.OPENROUTER_API_KEY ||
    env.VITE_AI_API_KEY ||
    env.VITE_TIMEWEB_AI_API_KEY ||
    env.VITE_OPENROUTER_API_KEY;

  const url = resolveChatCompletionsUrl(env);
  const model =
    env.AI_MODEL ||
    env.TIMEWEB_AI_MODEL ||
    env.OPENROUTER_MODEL ||
    env.VITE_AI_MODEL ||
    env.VITE_TIMEWEB_AI_MODEL ||
    env.VITE_OPENROUTER_MODEL ||
    DEFAULT_MODEL;

  return { apiKey, url, model, isOpenRouter: url.includes("openrouter.ai") };
}

const DEFAULT_OCR_MODEL = "gemini/gemini-2.5-flash";
const DEFAULT_RAW_TEXT_MODEL = "dashscope/qwen3.5-flash";

/** Vision/OCR: same gateway as grading, different model (Gemini Flash). */
export function getAiOcrConfig(env = process.env) {
  const base = getAiChatConfig(env);
  const model =
    env.AI_OCR_MODEL ||
    env.TIMEWEB_AI_OCR_MODEL ||
    env.VITE_AI_OCR_MODEL ||
    DEFAULT_OCR_MODEL;

  return { ...base, model };
}

/** Raw Text → markers: prefer Qwen unless AI_RAW_TEXT_MODEL overrides. */
export function getAiRawTextConfig(env = process.env) {
  const base = getAiChatConfig(env);
  const model =
    env.AI_RAW_TEXT_MODEL ||
    env.VITE_AI_RAW_TEXT_MODEL ||
    DEFAULT_RAW_TEXT_MODEL;

  return { ...base, model };
}

export function isAiConfigured(env = process.env) {
  return !!getAiChatConfig(env).apiKey;
}

export function buildChatHeaders(config) {
  const headers = {
    Authorization: `Bearer ${config.apiKey}`,
    "Content-Type": "application/json",
  };
  if (config.isOpenRouter) {
    headers["HTTP-Referer"] = "https://alex-academy.online";
    headers["X-Title"] = "АлексКласс";
  }
  return headers;
}
